<template>
  <LoadingSpinner
    v-if="loading"
    :status="$t('envelope.preparingDownload')"
  />

  <Download v-else-if="!ppPhase1Enabled" />

  <PasswordEntryScreen
    v-else-if="passwordNeeded"
    :passwordStatus="passwordStatus"
    message="passwordProtect.passwordRequiredDownloadMessage"
    :callback="downloadMeta"
    :branding="branding"
  />

  <DownloadScreen v-else />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useActions, useGetters } from 'vuex-composition-helpers/dist'
import { useFlagEnabled } from '@/composables/useFlagEnabled'

import PasswordEntryScreen from '@/components/screens/PasswordEntryScreen'
import DownloadScreen from '@/components/screens/DownloadScreen'
import Download from '@/views/Download'
import LoadingSpinner from '@/components/LoadingSpinner'

const [loadingFlags, ppPhase1Enabled] = useFlagEnabled('password-protection-phase1-sp')

const { branding, passwordNeeded, passwordStatus } = useGetters({
  branding: 'branding',
  passwordNeeded: 'auth/passwordNeeded',
  passwordStatus: 'auth/passwordStatus'
})

const loadingMeta = ref(false)

const loading = computed(() => loadingFlags.value || (ppPhase1Enabled.value && loadingMeta.value && !passwordNeeded.value))

const { downloadMeta } = useActions({
  downloadMeta: 'downloadMeta'
})

watch(loadingFlags, async () => {
  if (!loadingFlags.value && ppPhase1Enabled.value) {
    loadingMeta.value = true
    await downloadMeta()
    loadingMeta.value = false
  }
})
</script>
